import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { IconMailUp, IconPhoneCall } from '@tabler/icons-react'

import { Card, CardGrid } from '@/components/cards/Card'
import { PageHeader } from '@/components/headers/PageHeader'
import { hasChannelAccess } from '@/utils/helpers'
import { CHANNEL_TYPE } from '@/utils/constants'
import { Button } from '@/components/buttons/Button'

import './UploadInteractionsPage.scss'

const UploadInteractionsPage = () => {
  const history = useHistory()
  const { organizationid } = useSelector((state) => state.currentUser)
  const { active_channels: activeChannels = [] } = useSelector((state) => state.currentOrganization)
  const isBaltoAdmin = organizationid === 1
  const hasUploadEmailsAccess = hasChannelAccess(activeChannels, CHANNEL_TYPE.EMAIL, isBaltoAdmin)

  const interactionTypes = [
    {
      id: 'calls',
      title: 'Upload Calls',
      icon: <IconPhoneCall size={24} />,
      supportedFormat: '.wav, .wave, .mp3, .mp4, .m4a, .flac, .aac, .ogg, .opus, .webm, .flv',
      maxFileSize: '250MB',
      path: '/upload-calls',
      backgroundColor: 'var(--gradient-fill-success)',
      hasAccess: true,
    },
    {
      id: 'emails',
      title: 'Upload Emails',
      icon: <IconMailUp size={24} />,
      supportedFormat: '.eml',
      maxFileSize: '10MB',
      path: '/upload-emails',
      backgroundColor: 'var(--gradient-fill-brand)',
      hasAccess: hasUploadEmailsAccess,
    },
  ].filter((type) => type.hasAccess)

  const handleCardClick = (path) => {
    history.push(path)
  }

  return (
    <>
      <PageHeader
        data-testid="upload-interactions-page"
        title="Upload Interactions"
        description="Choose the type of interaction you want to upload"
      />
      <CardGrid>
        {interactionTypes.map((type) => (
          <Card
            key={type.id}
            title={type.title}
            icon={
              <div
                className="interaction-icon-container"
                style={{ backgroundImage: type.backgroundColor }}
              >
                {type.icon}
              </div>
            }
            data-testid={`${type.id}-card`}
          >
            <div className="mb">
              <div>
                <strong className="muted-text">Supported format:</strong> {type.supportedFormat}
              </div>
              <div>
                <strong className="muted-text">Max file size:</strong> {type.maxFileSize}
              </div>
            </div>
            <Button onClick={() => handleCardClick(type.path)} data-testid={`${type.id}-button`}>
              Get Started
            </Button>
          </Card>
        ))}
      </CardGrid>
    </>
  )
}

export default UploadInteractionsPage
